module.exports = __webpack_public_path__ + "img/deliveryLocations.f23f94e5.svg";